import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import Common_Logout, { LOGOUT_SUCCESS_MESSAGE } from "./Common_Logout";

function Session_Expired({ setSessionOut }) {
  const logoutMessage = useSelector(
    (state) => state?.logoutData?.data?.message
  );
  const { logout } = Common_Logout();

  React.useEffect(() => {
    if (logoutMessage === LOGOUT_SUCCESS_MESSAGE) {
      setSessionOut(false);
    }
  }, [logoutMessage]);

  return (
    <>
      <Modal show={true}>
        <Modal.Header>
          <Modal.Title>Session expired</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your session has been expired, and you have been logged out.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => logout()}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default React.memo(Session_Expired);
